// extracted by mini-css-extract-plugin
module.exports = {"promoUnit":"studios-promo-unit_promoUnit___OPSo","promoUnitTitle":"studios-promo-unit_promoUnitTitle__ZGBhm","promoUnitImage":"studios-promo-unit_promoUnitImage__I18TY"};